module.exports = __webpack_public_path__ + "static/img/icon-tip-green.88dfaeca.svg";